import React, { lazy, Suspense } from "react";
import { SuspenseLoader } from "../../../assets/loaders";

const LazyComponent = lazy(() => import("./audit"));

export default function Audit() {
  return (
    <Suspense fallback={<SuspenseLoader />}>
      <LazyComponent />
    </Suspense>
  );
}
